import { PAGING } from 'store/constants';
import { get } from 'lodash';
import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

const reducer = (state = initialState[PAGING], action) => {
  const fingerprint = get(action, 'meta.fingerprint', null);
  if (!fingerprint) return state;
  const { type, payload } = action;
  switch (type) {
    case types.CONFIGURE_PAGINATION: {
      const currentState = state[fingerprint];
      const newState = {
        ...currentState,
        ...payload
      };
      return {
        ...state,
        [fingerprint]: newState
      };
    }
    default:
      return state;
  }
};

export default reducer;
